var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', './search', 'component/report/transactions-table', 'app-common/component/api-call', 'app-common/component/loader', 'template/report/landing.htm', 'common/location'], function($, core, ReportSearchPage, transactionsTable, apiCall, loader, landingTemplate, location) {
  var UnmatchedReceiptsReportSearchPage;
  return UnmatchedReceiptsReportSearchPage = (function(_super) {

    __extends(UnmatchedReceiptsReportSearchPage, _super);

    function UnmatchedReceiptsReportSearchPage() {
      UnmatchedReceiptsReportSearchPage.__super__.constructor.apply(this, arguments);
    }

    UnmatchedReceiptsReportSearchPage.prototype.pageId = 'unmatched-receipts-search';

    /*
    # @param {Object} meta contains id, title and icon
        # @param {string} searchString
        # @param {number|null} data
    */


    UnmatchedReceiptsReportSearchPage.prototype.initialize = function(options, params) {
      var id;
      this.searchString = core.decodeSearchString(params[0]);
      this.returnToPath = options.returnToPath || null;
      this.returnToName = options.returnToName || null;
      this.receiptsMode = true;
      options = _.extend(options, {
        title: 'Search',
        icon: 'ss-list ss-standard',
        features: ['edit', 'search'],
        template: landingTemplate
      });
      UnmatchedReceiptsReportSearchPage.__super__.initialize.call(this, options, params);
      if (this.searchString === '') {
        if (this.returnToPath != null) {
          core.getRouter().loadPage(this.returnToPath);
        } else {
          core.getRouter().loadDefaultPage();
        }
        return;
      }
      if (this.searchString.substring(0, 3) === 'id:') {
        id = this.searchString.split(':')[1];
        return this.loadSpecificTransaction($.trim(id));
      } else {
        return this.loadData(1, this.searchString);
      }
    };

    UnmatchedReceiptsReportSearchPage.prototype.initExportReportLinks = function() {};

    UnmatchedReceiptsReportSearchPage.prototype.initReportDateIntervals = function() {};

    UnmatchedReceiptsReportSearchPage.prototype.getDownloadUrl = function() {
      var client, clientId, queryParams;
      client = core.getCurrentClient().toJSON();
      clientId = client.id;
      queryParams = $.param({
        pattern: encodeURIComponent(this.searchString)
      });
      return location.apiRoot + core.getConfig().apiPrefix + ("document.json/client/" + clientId + "/unmatched_receipts/search/downloadAsXls?" + queryParams);
    };

    UnmatchedReceiptsReportSearchPage.prototype.searchAction = function(searchKey) {
      var settings;
      settings = {
        returnToPath: this.returnToPath,
        returnToName: this.returnToName,
        queryVals: {
          searchkey: searchKey
        }
      };
      return core.getRouter().loadPage('unmatched-receipts-search', null, settings, 'Search: ' + searchKey);
    };

    UnmatchedReceiptsReportSearchPage.prototype.loadSpecificTransaction = function(transactionId) {
      var _this = this;
      this.loadingPromise = apiCall('document', transactionId, 'GET', null, 'json');
      this.addUnavailableMessage(this.loadingPromise);
      return this.loadingPromise.done(function(data) {
        if (!_this.UILoaded) {
          _this.initUI();
        }
        loader.hide();
        _this.data.items.push(data);
        _this.trigger('report:after-load-transactions', {
          page: {
            entries: [data]
          },
          pageCount: 1
        }, 1, null);
        if (_this.data.items.length > 0) {
          return _this.showTransaction({
            id: transactionId
          }, true, false);
        }
      });
    };

    UnmatchedReceiptsReportSearchPage.prototype.loadData = function(toPage, searchString) {
      var page, queryParams,
        _this = this;
      page = toPage || 1;
      queryParams = $.param({
        page: page,
        pattern: encodeURIComponent(this.searchString)
      });
      this.loadingPromise = apiCall('document', "client/" + (core.getCurrentClientId()) + "/unmatched_receipts/search?" + queryParams);
      return this.loadingPromise.done(function(data) {
        var transaction, _i, _len;
        if (!_this.UILoaded) {
          _this.initUI();
        }
        loader.hide();
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          transaction = data[_i];
          _this.data.items.push(transaction);
        }
        return _this.trigger('report:after-load-transactions', data, page, searchString);
      });
    };

    return UnmatchedReceiptsReportSearchPage;

  })(ReportSearchPage);
});
